<template>
<div class="xin">
    <div class="switch">
        <el-tabs v-show="user_list" @tab-click="edit_list">
            <!-- 管理员列表 -->

            <el-tab-pane label="管理员列表">
                <span slot="label">
                    {{ $t("logs.user_list1") }}
                </span>
                <div class="switch1">

                    <!-- 弹出框2-->

                    <!--  表格 -->
                    <div class="table table_one">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList1" :row-class-name="tableRowClassName" v-loading="loading" :cell-class-name="tableCellClassName">
                            <el-table-column prop="USERNAME" :label="$t('logs.user_list2')">
                            </el-table-column>
                            <el-table-column prop="TYPE" :label="$t('logs.smtpIp6')">
                            </el-table-column>
                            <el-table-column prop="SHOW_ISDEFAULT" :label="$t('logs.user_list3')">
                            </el-table-column>
                            <el-table-column prop="SHOW_ACTIVE" :label="$t('logs.Policy_list9')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">

                                    <!-- 编辑审核流程-->

                                    <el-button @click="bianji1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.user_list9") }}</el-button>
                                    <!-- 删除-->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small" class="iddefault" :disabled="$root.jurisdiction.only_query==0" 
                                    v-if="issuper==1 &&scope.row.ISDEFAULT==0"
                                    
                                    >{{ $t("table1.delete") }}</el-button>
                                </template>
                                <!-- 快编辑审核策略-->
                            </el-table-column>

                        </el-table>
                    </div>

                </div>
            </el-tab-pane>

            <!-- 增加管理员 -->

            <el-tab-pane label="增加管理员" v-if="this.ADD_ON==1">
                <span slot="label">
                    {{ $t("logs.user_list4") }}
                </span>
                <div class="switch1">

                    <div class="lie">
                        <table>
                            <tbody>
                                <tr>
                                    <!-- 管理员-->

                                    <td>{{ $t("logs.user_list2") }}:</td>
                                    <td>
                                        <el-input v-model="admin" placeholder></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 关联邮箱-->

                                    <td>{{ $t("logs.user_list5") }}:</td>
                                    <td>
                                        <el-input v-model="relation_email" placeholder></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 密码 -->
                                    <td>{{ $t("logs.user_list6") }}:</td>
                                    <td class="pass_word">
                                        <el-input v-model="passwd1" placeholder show-password style="margin-bottom:0"></el-input>
                                        <el-alert :title="this.pwd_hint" type="warning" show-icon :closable="false"></el-alert>

                                    </td>
                                </tr>
                                <tr>
                                    <!-- 确认密码-->

                                    <td>{{ $t("logs.user_list7") }}:</td>
                                    <td>
                                        <el-input v-model="passwd2" placeholder show-password></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 允许登录IP-->

                                    <td>{{ $t("logs.user_list8") }}:</td>
                                    <td>
                                        <el-input v-model="allow_ip" placeholder style="margin-bottom:0"></el-input>

                                        <el-alert :title="this.multi_address_hint" type="warning" show-icon :closable="false"></el-alert>
                                    </td>
                                </tr>

                                <tr>
                                    <td></td>
                                    <td style="display:flex;flex-direction:row">
                                        <el-button type="primary" @click="save_user" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-tab-pane>

        </el-tabs>
        <el-tabs v-show="edit_user">
            <!-- 编辑管理员 -->
            <el-tab-pane label="管理员列表">
                <span slot="label">
                    {{ $t("logs.user_list9") }}
                </span>
                <div class="switch1">

                    <div class="lie">

                        <table>
                            <tbody>
                                <tr>
                                    <!-- 管理员-->

                                    <td>{{ $t("logs.user_list2") }}:</td>
                                    <td>
                                        <p style="text-align:left;color:#0e2c5e;margin:8px 0px">{{this.admin}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 关联邮箱-->

                                    <td>{{ $t("logs.user_list5") }}:</td>
                                    <td>
                                        <el-input v-model="relation_email" placeholder></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 密码 -->
                                    <td>{{ $t("logs.user_list6") }}:</td>
                                    <td class="pass_word">
                                        <el-input v-model="passwd1" placeholder show-password style="margin-bottom:0"></el-input>
                                        <el-alert :title="this.pwd_hint" type="warning" show-icon :closable="false"></el-alert>

                                    </td>
                                </tr>
                                <tr>
                                    <!-- 确认密码-->

                                    <td>{{ $t("logs.user_list7") }}:</td>
                                    <td>
                                        <el-input v-model="passwd2" placeholder show-password></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 允许登录IP-->

                                    <td>{{ $t("logs.user_list8") }}:</td>
                                    <td>
                                        <el-input v-model="allow_ip" placeholder style="margin-bottom:0"></el-input>

                                        <el-alert :title="this.multi_address_hint" type="warning" show-icon :closable="false"></el-alert>
                                    </td>
                                </tr>

                                <tr>
                                    <td></td>
                                    <td style="display:flex;flex-direction:row">
                                        <el-button type="primary" @click="tanSend_user_list">{{$t('logs.save_a')}}</el-button>
                                        <el-button type="danger" @click="off_user">{{$t('logs.save_b')}}</el-button>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
    <!-- 查询框 -->

    <!--  底部 -->
</div>
</template>

<script>
export default {
    data() {
        return {
            issuper:'',
            allow_ip: '',
            passwd2: '',
            passwd1: '',
            relation_email: '',
            admin: '',
            edit_user: false,
            user_list: true,
            xian: false,
            btnText: "展示更多",
            checked: "",
            form: {
                username: "",
            },
            value: "",

            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "按天统计",
                },
                {
                    value: "选项2",
                    label: "按周统计",
                },
                {
                    value: "选项3",
                    label: "按月统计",
                },
                {
                    value: "选项4",
                    label: "按年统计",
                },
            ],

            emali: "",
            fileList1: [],
            loading: false,
            ADD_ON: '',
            multi_address_hint: '',
            pwd_hint: '',
        };
    },
    mounted() {
        this.getFileList1();
    },
    methods: {
        // 判断状态变色
        tableCellClassName({
            row,

        }) {
            // console.log(row);
         

            if (row.ISDEFAULT == '是') {
                // return "sent1";
                    console.log(1)
            }
            return "";
        },
        edit_list(a) {
            // console.log(a.index)
            if (a.index == 1) {
                this.admin = '';
                 this.passwd2=''
                        this.passwd1=''
                        this.relation_email=""
                        this.allow_ip=""
            }
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        // 管理员列表加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/admin.cgi", {
                    params: {
                        __mode: "list_admin",
                        sid: sid,

                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
           
             this.loading = false;
            
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList1 = res.data.ret.datalist;
                        this.ADD_ON = res.data.ret.ADD_ON;
                        this.issuper=res.data.ret.ISSUPER
                        this.pwd_hint = res.data.ret.pwd_hint;
                        this.multi_address_hint = res.data.ret.multi_address_hint;
                        // console.log(this.ISSUPER)

                    }
                })
               
        },
        // 编辑管理员保存
        save_user() {
            // this.user_list = false
            // this.edit_user = true
            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_admin",
                sid: sid,

                allow_ip: this.allow_ip,
                passwd2: this.passwd2,
                passwd1: this.passwd1,
                relation_email: this.relation_email,
                newadd: 1,
                admin: this.admin

            });
            this.$axios
                .post("/api/adm/cgi/admin.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList1();
                        this.passwd2=''
                        this.passwd1=''
                        this.relation_email=""
                        this.allow_ip=""
                        this.admin=""
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
               

        },
        // 新增管理员保存
        tanSend_user_list() {

            // this.loading = true;
            // this.tanchu = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            // console.log(col, '5555')
            let str = this.$qs.stringify({
                __mode: "save_admin",
                sid: sid,

                relation_email: this.relation_email,
                passwd1: this.passwd1,
                passwd2: this.passwd2,
                allow_ip: this.allow_ip,
                admin: this.admin,
                newadd: 0,

                // data_loadok: this.data_loadok_smtp

            });
            this.$axios
                .post("/api/adm/cgi/admin.cgi",
                    str
                    // screen: "real_filterlog.html",

                )
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.user_list = true
                        this.edit_user = false
                        this.loading = false;
                       
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                        //   this.$router.push({
                        //     name: "login",
                        // });

                    }
                })
               

        },
        // 编辑更改密码1
        bianji1(index, scope) {

            // console.log(index, scope);
            // this.admin = scope.USERNAME
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let admin = scope.USERNAME;
            let salt_minion_ip = this.salt_minion_ip1;

            this.$axios
                .get("/api/adm/cgi/admin.cgi", {
                    params: {
                        __mode: "edit_admin",
                        sid: sid,
                        admin: admin,
                        salt_minion_ip: salt_minion_ip,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.passwd1 = '',
                            this.passwd2 = '',
                            this.edit_user = true
                        this.user_list = false
                        this.loading = false;
                        this.admin = res.data.ret.ADMIN
                        this.allow_ip = res.data.ret.ALLOW_IP
                        this.relation_email = res.data.ret.RELATION_EMAIL
                        // this.getFileList();

                    }

                })

        },
        // 删除1
        handleClick1(index, scope) {
            console.log(index, scope);
            this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
                    confirmButtonText: `${this.$t("tan.confirm")}`,
                    cancelButtonText: `${this.$t("tan.cancel")}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    let admin = scope.USERNAME;
                    // let salt_minion_ip = this.salt_minion_ip1;

                    this.$axios
                        .get("/api/adm/cgi/admin.cgi", {
                            params: {
                                __mode: "delete_admin",
                                sid: sid,
                                admin: admin,
                                // salt_minion_ip: salt_minion_ip,
                            },
                        })
                        .then((res) => {
                            console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.loading = false;
                                this.getFileList1();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t("anti_gs1_tan.del1")}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t("anti_gs1_tan.del2")}`,
                    });
                });
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
            this.tanchu1 = false;
        },
        tan4: function () {
            this.tanchu = true;
            //   this.tanchu1 = false;
        },
        tanOff: function () {
            this.tanchu = false;
            //   this.tanchu1 = false;
        },
        off_user: function () {
            this.user_list = true
            this.edit_user = false

        }
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-table {
    height: calc(73vh - 1px);
}
/deep/ .has-gutter th {
  text-align: center;
}

// 表格居中位置
/deep/ .el-table__row td {
  text-align: center;
}
.main-find {
    width: 100%;
    height: 50px;
    padding-left: 10px;
    // padding-bottom: 5px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: left;

    border: 2px solid #D2D7E6;
    background: #FFFFFF;

    span {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;
    }

    .el-input {
        margin-right: 8px;
        width: 20%;
        line-height: 26px;
        height: 26px;
        // padding: 5px 10px 5px 0;

    }

    // input 框高度
    /deep/ .el-input__inner {
        height: 32px;
        padding: 0 6px;
    }

    /deep/ .el-input--suffix {
        width: 150px;
        margin-right: 10px;
    }

    /deep/ .el-button {
        margin-right: 10px;
        margin-left: 30px;
    }
}

/deep/ .sent1 .iddefault {
    // color: #f00 !important;
    display: none
}

/deep/ .el-input__suffix {
    right: 14px
}
 .pass_word {
flex: 1;
 }
 
 /deep/  .table_one .has-gutter th:nth-child(5) {
     .cell{
  text-align: left !important;

     }
}
/deep/  .table_one .el-table__row td:last-child  {
   .cell{
  text-align: left !important;

     }
}
</style>
